import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=447d45c6&"
import script from "./Detail.vue?vue&type=script&lang=ts&"
export * from "./Detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports